// 续住直连预订
import { OccType } from '@/config/constant';
import { DirectRenewalCreateAction } from '@/redux/actions/reservation/constant';
import { CommonBase, RentRoomInfo, RemarkInfo } from './base.d';

export interface CommonInfo extends CommonBase {
  mainOrderId?: string; // 续住 主订单id
  occNum: number; // 入住总人数
}

// 预订人信息
interface CustomerInfo {
  name: string;
  mobile: string;
  email: string;
  otaOrderNo: string;
  balance: number;
}

export interface RenewalRentRoomInfo extends RentRoomInfo {
  expectedDepartureTime: number; // 预离时间
  sourceChannelName: string; // 客源渠道
  otaOrderNo: string; // OTA虚拟号
  occType: OccType; // 入住类型
  occDuration: number; // 入住时长
  guestNames: string; // 宾客姓名
  recNo: string; // 子单号
  channelOrderNo: string; // 渠道单号
  targetId: string; // 续住单
}

export interface MainState {
  customerInfo: CustomerInfo; // 预订人信息
  rentRoomInfos: RenewalRentRoomInfo[]; // 入住房信息
  targetRoomMap: Record<string, RenewalRentRoomInfo>; // 预订单信息
  remarkInfo: RemarkInfo; // 备注
}

export interface ReducerState extends MainState {
  isInit: boolean; // 初始化
  isLoading: boolean; // 加载中
  isModify: boolean; // 是否有修改
}

const initialState: Partial<ReducerState> = {
  isInit: false,
  isLoading: true,
  isModify: false,
};

type ActionHandler<T> = (state: ReducerState, action: { payload: T }) => ReducerState;

const reducerMap = {
  [DirectRenewalCreateAction.initDefaultState]: <ActionHandler<Partial<ReducerState>>>((
    state,
    { payload },
  ) => {
    return { ...state, ...payload };
  }),
  [DirectRenewalCreateAction.setLoadingStatus]: <ActionHandler<boolean>>((state, { payload }) => {
    return { ...state, isLoading: payload };
  }),
  [DirectRenewalCreateAction.setInitStatus]: <ActionHandler<boolean>>((state, { payload }) => {
    return { ...state, isInit: payload };
  }),
  [DirectRenewalCreateAction.setRentRoomList]: <ActionHandler<RenewalRentRoomInfo[]>>((
    state,
    { payload },
  ) => {
    return { ...state, rentRoomInfos: payload };
  }),
};

export const reducerMapper = (state = initialState, action) => {
  const actionType = action.type;
  const reducer = reducerMap[actionType];
  if (typeof reducer === 'function') {
    return reducer(<ReducerState>state, action);
  }
  return state;
};

export const storeName = 'directRenewal';
